{
  "version": 1,
  "asset_id": "30eddff7-a180-4cb2-8c3a-671f7ac8bd6b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/30eddff7-a180-4cb2-8c3a-671f7ac8bd6b/loc-frisco-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/30eddff7-a180-4cb2-8c3a-671f7ac8bd6b/loc-frisco-1280.webp",
  "original_filename": "loc-frisco-1280.webp",
  "size": 65768,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:24Z"
}
